import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '@/services/sketchfab/index';
import * as _ from 'lodash';

export { ProductDefinitions } from './data';

export interface IProductDefinitionList {
  [key: string]: IProductDefinition;
}

export interface IProductDefinition {
  steps: IProductAssemblyDefinition[];
}

export interface IProductAssemblyDefinition {
  desc: string;
  order: number;
  apply: (repository: NodeObjectRepository,configuratorService?:ConfiguratorService) => void | Promise<any>;
}
type Func<T> = () => T;


export class Dispatcher {
  private _arr: Func<Promise<any>>[] = [];
  public dispatch(func: () => Promise<any>) {
    this._arr.push(func);
  }

  public reset() {
    this._arr = [];
  }

  public getAll() {
    return this._arr;
  }
}

export class NodeObjectRepository {

  constructor() {

  }

  private _objects: { [key: string]: NodeObjectModel } = {};

  private _trackedObjects: NodeObjectModel[] = [];



  public track(...objects: NodeObjectModel[]) {
    this._trackedObjects.push(...objects);
  }

  public get trackedObjects(): NodeObjectModel[] {
    return this._trackedObjects;
  }

  public load(...objects: NodeObjectModel[]) {
    _.each(objects, (o) => {
      this._objects[o.objectName] = o;
    });
  }

  public get(name: string): NodeObjectModel {
    return this._objects[name];
  }
}



export class NodeObjectModel {

  public readonly objectName: string;
  public readonly originX: number;
  public readonly originY: number;
  public readonly originZ: number;
  public currentX;
  public currentY;
  public currentZ;



  constructor(private _obj: NodeMap, private service: ConfiguratorService, private dispatcher: Dispatcher) {
    this.objectName = _obj.name;
    this.originX = this.currentX = this._obj.localMatrix[12];
    this.originY = this.currentY = this._obj.localMatrix[13];
    this.originZ = this.currentZ = this._obj.localMatrix[14];
  }

  private getObject(object: string): NodeMap {
    const operator = FilterOperators.Contains;

    const nodes = _.filter(this.service.nodes, (x: NodeMap) => {
      const name = _.trim(x.name);
      return this.service.filter(FilterOperators.Contains, object, name) && x.type === 'MatrixTransform';
    });

    if (nodes.length === 0) {
      return null;
    }

    return nodes[0];
  }

  public changePosition(xyz: (x: number, y: number, z: number) => { x?: number; y?: number, z?: number }, duration: number = 0.001, easing: Easing = 'easeInQuad') {

    const res = xyz(this.originX, this.originY, this.originZ);
    res.x = res.x || 0;
    res.y = res.y || 0;
    res.z = res.z || 0;

    this.currentX = this.originX + res.x;
    this.currentY = this.originY + res.y;
    this.currentZ = this.originZ + res.z;
    this.dispatcher.dispatch(() => this.service.Client.translate(this._obj.instanceID, [this.currentX, this.currentY, this.currentZ], duration, easing));
    return this;
  }

  public resetPosition(duration: number = 1, easing: Easing = 'easeOutQuad') {
    this.dispatcher.dispatch(() => this.service.Client.translate(this._obj.instanceID, [this.originX, this.originY, this.originZ], duration, easing));
    return this;
  }

  public show() {
    this.dispatcher.dispatch(() => this.service.showObjects({
      objects: [this.objectName],
      operator: FilterOperators.Contains,
    }));
    return this;
  }

  public hide() {
    this.dispatcher.dispatch(() => this.service.hideObjects({
      objects: [this.objectName],
      operator: FilterOperators.Contains,
    }));
    return this;
  }

  private _rotations = [];

  public rotate([radAngle, axisX, axisY, axisZ]: [number, number, number, number], duration: number = 0.01, easing: Easing = 'easeInQuad') {

    this.dispatcher.dispatch(() => this.service.Client.rotate(this._obj.instanceID, [radAngle, axisX, axisY, axisZ], duration, easing));
    return this;
  }

  public resetRotation([axisX, axisY, axisZ]: [number, number, number], duration: number = 0.001, easing: Easing = 'easeOutQuad') {
    this.dispatcher.dispatch(() => this.service.Client.rotate(this._obj.instanceID, [0, axisX, axisY, axisZ], duration, easing));
    return this;
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/models/assembly/index.ts